export const isSingleRequestPerOrderMerchant = (merchantId) =>
  String(merchantId) === "979";

export const singleRequestPerOrderNotice =
  "Please include all items you would like to return or exchange in this request. Only one return or exchange request can be placed per order.";
